import { jsx as _jsx } from "react/jsx-runtime";
import { Video as CotopaxiVideo } from '@as/cotopaxi';
import { useEffect, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { analyticsActions } from '../../redux/analytics/actions/AnalyticsActions.creators';
import { injectVimeoAPI, getVimeoId, addVimeoReadyEvent } from '../../util/VideoUtil';
export const VimeoVideo = ({ url, iframe, pause, stop, play, idPostfix = '', allowFullScreen, withOverlay, description, overlayTheme, poster, }) => {
    const player = useRef();
    const [showOverlay, setShowOverlay] = useState(withOverlay);
    const videoId = getVimeoId(url);
    const iframeId = `video_iframe_${videoId}${idPostfix}`;
    const dispatch = useDispatch();
    const onVimeoPlayerAPIReady = () => {
        const options = {
            id: videoId,
            dnt: true,
        };
        if (videoId) {
            dispatch(analyticsActions.productVideoLoaded(videoId.toString()));
        }
        if (window.Vimeo) {
            player.current = new window.Vimeo.Player(iframeId, options);
        }
    };
    const playVideo = () => {
        var _a;
        ((_a = player === null || player === void 0 ? void 0 : player.current) === null || _a === void 0 ? void 0 : _a.play) && player.current.play();
        showOverlay && setShowOverlay(false);
    };
    const pauseVideo = () => {
        var _a;
        ((_a = player === null || player === void 0 ? void 0 : player.current) === null || _a === void 0 ? void 0 : _a.pause) && player.current.pause();
    };
    const stopVideo = () => {
        var _a;
        ((_a = player === null || player === void 0 ? void 0 : player.current) === null || _a === void 0 ? void 0 : _a.unload) && player.current.unload();
    };
    useEffect(() => {
        injectVimeoAPI();
        addVimeoReadyEvent(onVimeoPlayerAPIReady);
    }, []);
    useEffect(() => {
        pause && pauseVideo();
    }, [pause]);
    useEffect(() => {
        play && playVideo();
    }, [play]);
    useEffect(() => {
        stop && stopVideo();
    }, [stop]);
    return (_jsx(CotopaxiVideo, { url: url, iframe: iframe, iframeId: iframeId, allowFullScreen: allowFullScreen, withOverlay: showOverlay, description: description, onOverlayClick: playVideo, overlayTheme: overlayTheme, poster: poster }));
};
